module.exports = __webpack_public_path__ + "img/pager5img.0030c0cd.png";